import { HttpContextToken } from '@angular/common/http';

export const SkipByLoadingInterceptor = new HttpContextToken(() => true);
